import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueLazyload from 'vue-lazyload'
import vuescroll from 'vuescroll'

import { Toast } from '@/plugins/Toast/index.js'

import '@/directives/report/index.js'
import '@/directives/unshow/index.js'

Vue.config.productionTip = false

Vue.use(Toast)

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
  dispatchEvent: true
})

Vue.use(vuescroll, {
  ops: {
    mode: 'native',
    bar: {
      background: '#E5E5E5',
      keepShow: true,
      size: '4px'
    }
  } // 在这里设置全局默认配置
})

window.app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
